<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Picking Card Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
				<app-input-combobox-autocomplete :options="pickingForDeliveryDetails" optionsLabel="deliveryInstructionDetail" optionsKey="id" label-cols-lg="12" label="Picking Detail" id="input-" size="sm" :model.sync="model.pickingDetailId"   :selected="model.pickingDetail != null ? model.pickingDetail.deliveryInstructionDetail : ''" @input="getPickingForDeliveryDetails" />
				<app-input-combobox-autocomplete :options="deliveryInstructionDeliveryCards" optionsLabel="deliveryCardNumber" optionsKey="id" label-cols-lg="12" label="Delivery Card" id="input-" size="sm" :model.sync="model.deliveryCardId" :isRequired="true" :state="validateState('deliveryCardId')" :errorMessage="getErrorMessage(errorMessage.deliveryCardId, 'deliveryCardId')"   :selected="model.deliveryCard != null ? model.deliveryCard.deliveryCardNumber : ''" @input="getDeliveryInstructionDeliveryCards" />
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="input-" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-datetimepicker id="fieldset-scan-date" label-cols-lg="12" label="Scan Date" size="sm" :model.sync="model.scanDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Scan By" id="input-" size="sm" :model.sync="model.scanById"   :selected="model.scanBy != null ? model.scanBy.firstName : ''" @input="getUserInfos" />
				<app-input-textbox id="fieldset-delivery-qty" label-cols-lg="12" label="Delivery Qty" label-for="input-delivery-qty" size="sm" :model.sync="model.deliveryQty"  />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import PickingCardDetail from '@/models/PickingForDelivery/PickingCardDetail';
import PickingCardDetailFilter from '@/filters/PickingForDelivery/PickingCardDetailFilter';

import PickingForDelivery from '@/models/PickingForDelivery/PickingForDelivery';
import PickingForDeliveryFilter from '@/filters/PickingForDelivery/PickingForDeliveryFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PickingForDeliveryDetail from '@/models/PickingForDelivery/PickingForDeliveryDetail';
import PickingForDeliveryDetailFilter from '@/filters/PickingForDelivery/PickingForDeliveryDetailFilter';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PopupRouterView,
		AppInputScan,
	},
	mixins : [validationMixin, focusInput],
	validations: {
		model: {
		deliveryCardId: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				deliveryCardId: { required : "Delivery Card is Required."},
			},
			pickingForDeliveryDetails : [],
			deliveryInstructionDeliveryCards : [],
			controlCards : [],
			userInfos : [],
			isBusy: false,
		}
	},
	methods : {
		getPickingCardDetail : async function(id) {
			this.isBusy = true;
			PickingCardDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getPickingForDeliveryDetails : async function(input) {
			let filter = new PickingForDeliveryDetailFilter();
			if (input != undefined) {
				filter.deliveryInstructionDetail = input;
			}
			PickingForDeliveryDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingForDeliveryDetails = result.data
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructionDeliveryCards : async function(input) {
			let filter = new DeliveryInstructionDeliveryCardFilter();
			if (input != undefined) {
				filter.deliveryCardNumber = input;
			}
			DeliveryInstructionDeliveryCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDeliveryCards = result.data
				}
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getPickingForDeliveryDetails();
		//this.getDeliveryInstructionDeliveryCards();
		//this.getControlCards();
		//this.getUserInfos();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPickingCardDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getPickingForDeliveryDetails();
				this.getDeliveryInstructionDeliveryCards();
				this.getControlCards();
				this.getUserInfos();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPickingCardDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
